import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/juzmatch`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const juzmatchApi = {
  getMember: (request) => {
    const { config } = request
    return instance().get('/member_profile', config)
  },
  getMemberWithAsset: (request) => {
    const { config } = request
    return instance().get('/profile_with_assets', config)
  },
  patchMember: (request) => {
    const { body } = request
    return instance().put('/member_profile', body)
  },
  updateMember(data) {
    return instance().put('/cms/member', data)
  },
  getMemberHistoryItems(params) {
    return instance().get('/cms/member/history', { params })
  }
}
export default juzmatchApi



// WEBPACK FOOTER //
// ./src/api/juzmatch.js